<div class="results-panel-header" [title]="coverageTitle">
  <span class="results-panel-header__title">{{ coverageTitle }}</span>
  <div class="search-facets-toggle" role="group" aria-label="Coverage sort">
    <button type="button" [class.active]="sortSelected === 'recent'" [attr.aria-pressed]="sortSelected === 'recent'" (click)="sortChange('recent')">Recent</button>
    <button type="button" [class.active]="sortSelected === 'relevant'" [attr.aria-pressed]="sortSelected === 'relevant'" (click)="sortChange('relevant')">Relevant</button>
  </div>
</div>
<app-loading [isLoading]="isLoadingContent"></app-loading>
<app-content-items
  [parentName]="parentName"
  [items]="feeds"
  [loading]="loading"
  [pageSize]="pageSize"
  [page]="page"
  [total]="total"
  [keywords]="keywords"
></app-content-items>
<div class="p-d-flex p-jc-between coverage-footer">
  <div>
    <p-paginator
      #pp
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ total | number }} total items"
      [pageLinkSize]="3"
      [showFirstLastIcon]="false"
      (onPageChange)="getPage($event)"
      [rows]="pageSize"
      [totalRecords]="total"
      [showPageLinks]="showPageButton"
    >
    </p-paginator>
  </div>
  <div class="p-pl-2 footerContent" *ngIf="showSort">
    <button
      pButton
      class="p-button-outlined p-button-secondary p-button-sm"
      icon="pi pi-bookmark"
      [label]="saveAsTopicLabel"
      *ngIf="searchLoaded"
      (click)="handleSaveSearchAsTopic()"
    ></button>
    <p-dropdown
      [options]="exportOptions"
      optionLabel="label"
      optionValue="value"
      optionDisabled="disabled"
      [showClear]="false"
      appendTo="body"
      [ngModel]="selectedExportValue || 'placeholder'"
      (onChange)="handleExport($event)"
      styleClass="coverage-export"
    >
      <ng-template pTemplate="selectedItem"><span class="export-selected-item"><i [class]="isExportingExcel || isExportingText ? 'pi pi-spin pi-spinner' : 'pi pi-download'" aria-hidden="true"></i> Export</span></ng-template>
      <ng-template pTemplate="item" let-option><i [class]="option.icon"></i> {{ option.label }}</ng-template>
    </p-dropdown>
    <button
      [pTooltip]="reportMissingLabel"
      pButton
      class="p-button-outlined p-button-secondary p-button-sm"
      icon="pi pi-flag"
      label=""
      (click)="openReportMissingDataModal()"
    ></button>
  </div>
</div>
